import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaStatus } from './shared/components/pwa-status/pwa-status';
import { ToastHost } from './shared/components/toast-host/toast-host';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastHost, PwaStatus],
  template: `
    <app-pwa-status />
    <app-toast-host />
    <router-outlet />
  `,
  styles: `
    :host {
      display: block;
      min-height: 100dvh;
    }
  `,
})
export class App {}
